<template>
  <ButtonBase
    :text="text"
    :size="size"
    :type="type"
    class="btn--secondary"
    @click-button="onClick"
  >
    <slot>{{ text }}</slot>
  </ButtonBase>
</template>

<script>
import ButtonBase from '../../atoms/buttons/ButtonBase.vue'
export default {
  components: { ButtonBase },
  props: {
    text: {
      type: String,
      required: true
    },
    size: {
      type: String,
      required: false,
      default: 'regular',
      validator: value => ['regular', 'small'].includes(value)
    },
    type: {
      type: String,
      required: false,
      default: 'submit',
      validator: value => ['button', 'submit', 'reset'].includes(value)
    }
  },
  methods: {
    onClick() {
      this.$emit('click-secondary-button')
    }
  }
}
</script>

<style lang="scss" scoped>
.btn--secondary {
  background-color: $white;
  color: $primary;
  border-color: $primary;

  a {
    color: $primary;
  }
}
</style>
